import { UserLanguageCode } from '@/app/store/api/restApi';

export const DEFAULT_LANGUAGE_CODE: UserLanguageCode = UserLanguageCode.Ru;
